module.exports = __webpack_public_path__ + "img/flu-1.6f0ab078.svg";